module.exports = __webpack_public_path__ + "img/ic_design_item6.4f7f55fe.png";